export const part_table_examples = [
    {
        image: "https://github.com/user-attachments/assets/6b248124-f6c2-41a8-8601-8f0e9daa7d30",
        example_link: "https://2025.igem.wiki/bielefeld-cebitec/parts",
        example_text: "Bielefeld-CeBiTec 2025"
    },
    {
        image: "https://github.com/user-attachments/assets/049c00f2-ec81-431f-98e3-e67d057d1318",
        example_link: "https://2026.igem.wiki/bielefeld-cebitec/parts",
        example_text: "Initial design draft for Bielefeld-CeBiTec 2026"
    },
    {
        image: "https://github.com/user-attachments/assets/573500a0-6a0a-4974-9dff-524d244a1d47",
        example_link: "",
        example_text: "design-less example with images"
    }
]


export const protocol_pdfs_1 = [
    {
        image: "https://github.com/user-attachments/assets/4b5029c2-b6c5-4e04-b6c8-57a449bb79b9",
        example_link: "",
        example_text: "Initial design draft for Bielefeld-CeBiTec 2026"
    },
    {
        image: "https://github.com/user-attachments/assets/d881e039-3b0e-4cfd-977f-259050dfb211",
        example_link: "",
        example_text: "design-less example"
    }
]

export const HP_Timeline_Overview_with_Interviews_below = [
    {
        image: "https://github.com/user-attachments/assets/75abb41e-ceca-4518-b87e-dbaea009e917",
        example_link: "",
        example_text: "Initial design draft for Bielefeld-CeBiTec 2026"
    }
]

export const Engineering_Cycle_Carousel_Style = [
    {
        image: "https://github.com/user-attachments/assets/b8be7ca0-86c9-428f-9456-767ba0b0ad6a",
        example_link: "",
        example_text: "Initial design draft for Bielefeld-CeBiTec 2026"
    },
    {
        image: "https://github.com/user-attachments/assets/d41a221f-350c-4fc4-9e26-7060d1676397",
        example_link: "",
        example_text: "Design draft for Bielefeld-CeBiTec 2026 with progress bar activated"
    }
]

export const Instagram_Post = [
    {
        image: "https://github.com/user-attachments/assets/0024da6d-dacb-456c-a938-e7722a96fb2b",
        example_link: "",
        example_text: "Initial design draft for Bielefeld-CeBiTec 2026"
    }
]

export const figure_automatic = [
    {
        image: "https://github.com/user-attachments/assets/693c8c6c-6989-435e-8e0b-979107fcdd24",
        example_link: "",
        example_text: "Initial design draft for Bielefeld-CeBiTec 2026"
    }
]